import { injectIntl } from "react-intl";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const formatCtrAxis = (value) => `${value}%`;

const ClickThroughRateTrend = ({ data = [] }) => {
  const ctrValues = data.map((item) => item.ctr).filter((v) => v != null);
  const minCtr = ctrValues.length
    ? Math.floor(Math.min(...ctrValues) * 10) / 10
    : 0;
  const maxCtr = ctrValues.length
    ? Math.ceil(Math.max(...ctrValues) * 10) / 10
    : 1;
  const padding = (maxCtr - minCtr) * 0.1 || 0.1;

  return (
    <div className="SmsAnalyticsChartCard SmsAnalyticsChartCardNarrow">
      <div className="SmsAnalyticsChartTitle">Click-Through Rate (CTR)</div>
      <ResponsiveContainer width="100%" height={280}>
        <LineChart
          data={data}
          margin={{ top: 10, right: 10, left: 0, bottom: 0 }}
        >
          <CartesianGrid stroke="#F0F1F5" vertical={false} />
          <XAxis
            dataKey="month"
            axisLine={false}
            tickLine={false}
            tick={{ fill: "#8185A8", fontSize: 12, fontFamily: "Inter" }}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tickFormatter={formatCtrAxis}
            tick={{ fill: "#8185A8", fontSize: 12, fontFamily: "Inter" }}
            width={50}
            domain={[minCtr - padding, maxCtr + padding]}
          />
          <Tooltip
            formatter={(value) => [`${value}%`, "CTR"]}
            contentStyle={{
              borderRadius: 8,
              border: "1px solid #E5E7F0",
              fontSize: 12,
              fontFamily: "Inter",
            }}
          />
          <Line
            type="monotone"
            dataKey="ctr"
            stroke="#EC4899"
            strokeWidth={2}
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default injectIntl(ClickThroughRateTrend);
